import React, { Fragment } from "react";
import ToolBoxItem from "./ToolBoxItem";
import propTypes from "prop-types";

import { getToolBoxItemByRef } from "./ToolBoxItems";
import { WorkflowAction, IWorkflowToolBoxItem } from "../../../../logic/api";


const ToolBox: React.FunctionComponent<{
    selected: WorkflowAction | null;
    onItemClicked: (item: IWorkflowToolBoxItem) => void,
    toolBoxItems: IWorkflowToolBoxItem[];
}> = (props) => {
    const selectedToolBoxItem = props.selected == null ? null : getToolBoxItemByRef(props.toolBoxItems, props.selected.toolRef);

    return <div style={{ padding: 5 }}>
        {props.toolBoxItems.map((item, key) => {
            if (selectedToolBoxItem != null) {
                if (selectedToolBoxItem.compatChildRefs.indexOf(item.ref) == -1 && selectedToolBoxItem.compatChildRefs.indexOf("*") == -1) {
                    return <Fragment key={key}></Fragment>
                }
            }
            return <Fragment key={key}>
                <ToolBoxItem toolBoxItems={props.toolBoxItems} item={item} onItemClicked={() => {
                    props.onItemClicked(item);
                }}></ToolBoxItem>
            </Fragment>
        })}
    </div>
}
ToolBox.propTypes = {
    onItemClicked: propTypes.func.isRequired,
    toolBoxItems: propTypes.any.isRequired,
    selected: propTypes.any
}
export default ToolBox;